window.cart =
{
    bindQuickOrderImportForm: function (form)
    {
        var inputFile = form.querySelector("input[type='file']");
        inputFile.addEventListener("change", () =>
        {
            if (inputFile.files.length === 0)
                return;

            form.submit();
        });

        var button = form.querySelector("button");
        button.addEventListener("click", () =>
        {
            inputFile.click();
        });
    },
    bindQuickOrderAutocomplete: function ()
    {
        var autoCompleteDataList = "quick-order-autocomplete";
        var input = document.querySelector(`input[list='${autoCompleteDataList}']`);

        if (!input)
            return;

        var timer = null;

        input.addEventListener("input", async () =>
        {
            var data = null;
            var dataList = document.getElementById(autoCompleteDataList);

            if (!dataList)
                return;

            clearTimeout(timer);

            if (input.value.trim().length == 0)
            {
                dataList.innerHTML = "";

                return;
            }

            timer = setTimeout(async () =>
            {

                try
                {
                    var response = await fetch(`${document.baseURI}api/product/search/${input.value}`);

                    if (!response.ok)
                        throw new Error(await response.text());

                    data = await response.json();
                }
                catch (error)
                {
                    console.log(error);

                    return;
                }

                dataList.innerHTML = "";

                for (var item in data)
                {
                    var option = document.createElement("option");
                    option.value = item;
                    option.text = data[item];

                    dataList.appendChild(option);
                }

                // refocus
                input.blur();

                setTimeout(() =>
                {
                    input.focus();
                }, 10);
            }, 300);
        });
    },
    CTA: function ()
    {
        var handHeldToolbar = document.querySelector(".handheld-toolbar");
        var button = document.querySelector("*[data-cta-stop]");

        if (!handHeldToolbar || !button)
            return;

        var buttonOffset = document.querySelector("*[data-cta-stop]").offsetTop;
        var toolbarHeight = handHeldToolbar.getBoundingClientRect().height;

        var ctaElement = document.querySelector("*[data-cta]");

        if (!ctaElement)
            return;

        if (window.scrollY + window.outerHeight >= buttonOffset + toolbarHeight)
        {
            ctaElement.classList.add("d-none");
            handHeldToolbar.classList.remove("shadow-none");
        }
        else
        {
            ctaElement.classList.remove("d-none");
            handHeldToolbar.classList.add("shadow-none");
        }
    },
    // Odebrání položky z košíku
    deleteRow: function (cartItemId)
    {
        var element = document.querySelector("*[data-cart-row-id='" + cartItemId + "']");

        if (element === null)
            return;

        element.remove();

        var elements = document.querySelectorAll("*[data-cart-row-id]");

        if (elements.length > 0)
            return;

        window.location.reload();
    },
    showModal: function ()
    {
        var cartModal = document.getElementById("cart-modal");

        if (!cartModal)
            return;

        // If the cart modal is already visible we do not call .show() again (prevents duplicate backdrops)
        if (cartModal.classList.contains("show"))
        {
            // Optionally force focus back into the modal after content replacement
            setTimeout(() =>
            {
                cartModal.focus();
            }, 0);

            return;
        }

        // Hide any other open modals to avoid stacking
        var openModals = document.querySelectorAll(".modal.show");

        for(let modal of openModals)
        {
            if (modal === cartModal)
                continue;

            var instance = bootstrap.Modal.getInstance(modal);

            if (!instance)
                instance = new bootstrap.Modal(m);

            instance.hide();
        }

        // Remove any existing backdrops left behind (defensive cleanup)
        document.querySelectorAll(".modal-backdrop")
            .forEach(x => x.remove());

        document.body.style.overflow = null;

        // Reuse existing instance if present, otherwise create a new one
        var cartModalInstance = bootstrap.Modal.getInstance(cartModal);

        if (!cartModalInstance)
            cartModalInstance = new bootstrap.Modal(cartModal);

        cartModalInstance.show();
    },
    init: function ()
    {
        cart.bindQuickOrderAutocomplete();

        var quickOrderImportFormSelector = "#quick-import-form";

        var quickOrderImportForm = document.querySelector(quickOrderImportFormSelector);

        if (quickOrderImportForm)
            cart.bindQuickOrderImportForm(quickOrderImportForm);

        document.addEventListener("onElementContentChanged", event =>
        {
            if (event.detail.target !== "#quick-order-bar")
                return;

            cart.bindQuickOrderAutocomplete();

            var quickOrderImportForm = document.querySelector(quickOrderImportFormSelector);

            if (quickOrderImportForm)
                cart.bindQuickOrderImportForm(quickOrderImportForm);
        });

        var cartItemsContainer = document.querySelector('#cart-items-container');

        if (!cartItemsContainer)
            return;

        window.addEventListener("scroll", cart.CTA);

        cart.CTA();
    }
};

//export default cart;